import custom_axios from "../axios";


export const CREATE_TOTES = async(count)=>{
    try {
        const response = await custom_axios.post(`/totes/`,{
            count:count
        });
        return response.data;
    } catch (error) {
        console.error("Failed to create totes:", error);
        throw error;
    }
}

export const FETCH_TOTES = async(queryParams)=>{
    try {
        const queryString = queryParams
        .map((param) =>
          param.value ? `${param.key}=${encodeURIComponent(param.value)}` : ""
        )
        .filter(Boolean)
        .join("&");

        const response = await custom_axios.get(`/totes?${queryString}`);

        return response.data;
    } catch (error) {
        console.error("Failed to fetch totes:", error);
        throw error;
    }
}
export const FETCH_TOTES_DETAILS = async (toteId, queryParams) => {
    try {
      const queryString = queryParams
        .map((param) =>
          param.value ? `${param.key}=${encodeURIComponent(param.value)}` : ""
        )
        .filter(Boolean)
        .join("&");
  
      const response = await custom_axios.get(
        `/totes/tote-assigned-orders-details/${toteId}?${queryString}`
      );
  
      return response.data;
    } catch (error) {
      console.error("Failed to fetch totes:", error);
      throw error;
    }
  };

export const DELETE_TOTES_BY_CODES = async(codes)=>{
    try {
        const response = await custom_axios.post(`/totes/delete-totes`,{
            tote_codes:codes
        });
        return response.data;
    } catch (error) {
        console.error("Failed to delete totes:", error);
        throw error;
    }
}

export const EMPTY_TOTES_BY_CODES = async(codes)=>{
    try {
        const response = await custom_axios.post(`/totes/empty-totes`,{
            tote_codes:codes
        });
        return response.data;
    } catch (error) {
        console.error("Failed to empty totes:", error);
        throw error;
    }
}

export const REMOVE_TOTE_ORDERS = async (toteId, data) => {
    try {
      const response = await custom_axios.post(`/totes/remove-tote-orders/${toteId}`, data);
      return response.data;
    } catch (error) {
      console.error("Failed to remove tote orders:", error);
      throw error;
    }
  };